var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/shareProductPage.58bffc72.png","uri@2x": __webpack_public_path__ + "static/media/shareProductPage.e25fe56d.png","uri@3x": __webpack_public_path__ + "static/media/shareProductPage.571b9a5d.png",
    width: 24,
    height: 24
});